import { useState } from "react";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent } from "@/lib/consent";
import { PRIVACY_POLICY_URL } from "@/lib/legal";

export function CookieConsent() {
  const [visible, setVisible] = useState(() => getConsent() === null);

  if (!visible) return null;

  function choose(value: "accepted" | "rejected") {
    setConsent(value);
    setVisible(false);
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 p-4">
      <div className="mx-auto flex max-w-3xl flex-col gap-3 rounded-lg border bg-background p-4 shadow-lg sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground">
          Używamy niezbędnych plików cookie, aby panel działał poprawnie. Za
          Twoją zgodą używamy też plików do analizy i wsparcia (nagrywanie sesji,
          czat). Szczegóły w{" "}
          <a
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium underline underline-offset-2"
          >
            Polityce prywatności
          </a>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" size="sm" onClick={() => choose("rejected")}>
            Tylko niezbędne
          </Button>
          <Button size="sm" onClick={() => choose("accepted")}>
            Akceptuję wszystkie
          </Button>
        </div>
      </div>
    </div>
  );
}
